import React from 'react';
import { connect } from 'react-redux';
import { cnBem } from '@carnica/utils';
import { Header } from "../../../../widgets/header/ui";
import { Search } from "../../../../features/search/ui";
import { ClosePreview } from "../../../../features/close-preview/ui";
import { BackMenu } from "../../../../features/back-menu/ui";
import { selectIsImgPreviewOpen } from "../../../../entities/message/model";
import { HeaderTitle } from "../HeaderTitle";
import styles from "./styles.pcss";
var cnChatHeader = cnBem('chat-header', styles);
var ChatHeaderRender = function ChatHeaderRender(_ref) {
  var isImgPreviewOpen = _ref.isImgPreviewOpen;
  return /*#__PURE__*/React.createElement(Header, {
    className: cnChatHeader('', {
      preview: isImgPreviewOpen
    })
  }, /*#__PURE__*/React.createElement(HeaderTitle, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClosePreview, {
    shouldRender: isImgPreviewOpen
  }), /*#__PURE__*/React.createElement(BackMenu, {
    shouldRender: !isImgPreviewOpen
  }))), /*#__PURE__*/React.createElement(Search, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isImgPreviewOpen: selectIsImgPreviewOpen(state)
  };
};
export var ChatHeader = connect(mapStateToProps)(ChatHeaderRender);